import $ from "jquery";

export const init = () => {
  let attempts = 0;

  // Search field --------------------------------------------------------------

  /*$(".search-trigger").click(function () {
				return $(this).toggleClass("search-trigger-transform"), $(this).next(".searchbox").fadeToggle("normal"), $("#q").focus(),	!1;
			});*/

  // Debounce function to suppress ajax calls on every keypress
  Function.prototype.debounce = function (wait) {
    let timeout;
    let debouncedFunc = this;
    return function () {
      let context = this;
      function later(args) {
        timeout = null;
        debouncedFunc.apply(context, args);
      }
      clearTimeout(timeout);
      timeout = setTimeout(later, wait, arguments);
    };
  };

  // Remove existing suggestions and shrink search field
  function resetSuggestions() {
    $(".searchbox .pinnedSearch").slideUp(function () {
      $(".searchbox").removeClass("large");
      $(".searchbox .pinnedSearch").remove();
    });
  }

  // Ajax pinned search ajax search method
  function search(searchTerm) {
    let params = new URLSearchParams({
      searchTerm: searchTerm,
      categoryParent: pinnedSearchParent,
    });

    fetch(`${currentPageUrl}?type=105736&cmd=pinnedSearch&${params}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => response.json())
      .then((data) => {
        if (process.env.NODE_ENV !== "production") {
          data = {
            request: { term: "umwelt", parent: 571 },
            results: [
              {
                title:
                  "Die \u00c4rmsten trifft der Klimawandel am h\u00e4rtesten",
                description:
                  "Immer mehr \u00dcberschwemmungen, heftige Unwetter und t\u00f6dliche D\u00fcrren: Der Klimawandel wirkt sich bereits auf Millionen Menschen aus und bedroht die \u00c4rmsten.",
                _keywords: [{ title: "Klimawandel" }, { title: "Umwelt" }],
                _url: "/themen/klimawandel/",
                _image:
                  "/fileadmin/_processed_/1/5/csm_IMG_2429_a1bf60eaf9.jpg",
              },
            ],
          };
        }

        let searchbox = $(".searchbox");

        if (data.results !== undefined && data.results.length > 0) {
          let buildResults = function (data) {
            let html = "";
            for (let i = 0; i < data.results.length; i++) {
              html +=
                '<div class="result">' +
                '<a href="' +
                data.results[i]._url +
                '" class="result-box">';

              if (data.results[i]._image) {
                html +=
                  '<div class="image-box"><img alt="" src="' +
                  data.results[i]._image +
                  '"/></div>';
              }

              html +=
                '<div class="text-box">' +
                '<div class="title lead"><strong>' +
                data.results[i].title +
                "</strong></div>" +
                '<div class="description lead">' +
                data.results[i].description +
                "</div>";

              if (data.results[i]._keywords) {
                html += '<div class="keywords">';
                for (let j = 0; j < data.results[i]._keywords.length; j++) {
                  if (j > 0 && j < data.results[i]._keywords.length) {
                    html += ", ";
                  }
                  html += data.results[i]._keywords[j].title;
                }
                html += "</div>";
              }

              html += "</div>" + "</a>" + "</div>";
            }
            return html;
          };

          let allResults = function () {
            return (
              '<div class="link_results">' +
              '<a href="javascript:void(0);" onclick="document.getElementById(\'searchbox\').submit();">' +
              "Alle Suchergebnisse &gt;" +
              "</a>" +
              "</div>"
            );
          };

          // Enlarge search box if there are results
          if (!searchbox.hasClass("large")) {
            searchbox.addClass("large");
          }

          if (searchbox.find(".pinnedSearch").length > 0) {
            searchbox.find(".pinnedSearch .result").slideUp(function () {
              searchbox.find(".pinnedSearch .result").remove();

              let html = buildResults(data);

              searchbox.find(".pinnedSearch").prepend(html);
              searchbox.find(".pinnedSearch .result").slideDown();
            });
          } else {
            // Clear existing results
            searchbox.find(".pinnedSearch").remove();

            // Build html for suggestions
            let html = '<div class="pinnedSearch">';
            html += buildResults(data);
            html += allResults();
            html += "</div>";

            // Append suggestions to searchbox
            $(".searchbox").append(html);
            searchbox.find(".pinnedSearch .result").show();
            setTimeout(function () {
              $(".searchbox .pinnedSearch").slideDown();
            }, 300);
          }
        } else {
          // Clear suggestions if ajax response has no results
          resetSuggestions();
        }
      })
      .catch((error) => {
        console.error("Fehler beim Abrufen der Daten:", error);
        resetSuggestions();
      });
  }

  const whenComplete = () => {
    if (++attempts > 30) return;
    if (document.readyState === "complete") {
      $(".searchbox input#q").keyup(
        function (e) {
          let searchTerm = $(this).val();
          // Clear suggests and minimize search field or search
          if (searchTerm.length === 0) {
            resetSuggestions();
          } else if (searchTerm.length > 2) {
            search(searchTerm);
          }
        }.debounce(600)
      );
    } else {
      setTimeout(() => whenComplete(), 400);
    }
  };
  whenComplete();
};
